// extracted by mini-css-extract-plugin
module.exports = {"notification":"Notification_notification__pERJa","isWarning":"Notification_isWarning__2pQb5","visible":"Notification_visible__SDFmo"};